import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },

  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '12%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '12%',
    padding: 6,
    // textAlign: 'start',
    // alignItems: 'center',
    textAlign: 'center'
  },
  columnNumberContent: {
    width: '12%',
    padding: 6,
    textAlign: 'right',
    alignItems: 'center',
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IndoorCollectionRegisterReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }


  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title="Indoor Collection Register Report">
        <Page style={styles.page} size="A4" orientation="landscape">
          <PDFImage
            src="/logo_Hospital_m.jpeg"
            style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
          />
          <View style={styles.row}>
            <Text style={{ ...styles.columnHeader, width: '8%' }} content="Sr No." />
            <Text style={styles.columnHeader} content=" Bill Date" />
            <Text style={styles.columnHeader} content="Type" />
            <Text style={{ ...styles.columnHeader, width: '26%' }} content="Patient Name" />
            <Text style={{ ...styles.columnHeader, width: '11%' }} content="Uhid No" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Adm No" />
            <Text style={{ ...styles.columnHeader, width: '12%' }} content="Pay Mode" />
            <Text style={{ ...styles.columnHeader, width: '24%' }} content="Consultant" />
            <Text style={{ ...styles.columnHeader, width: '18%' }} content="Services" />
            <Text style={{ ...styles.columnHeader, width: '12%' }} content="Panel" />
            <Text style={{ ...styles.columnHeader, width: '11%' }} content="Bill Amt." />
            <Text style={styles.columnHeader} content="Dis Amt." />
            <Text style={styles.columnHeader} content="Recd Amt." />
            <Text style={styles.columnHeader} content="Bal. Amt." />
            <Text style={{ ...styles.columnHeader, width: '15%' }} content="Username" />
          </View>
          {data &&
            data?.indoorServiceData?.data?.map((data, index) => (
              <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                <Text style={{ ...styles.columnContent, width: '8%' }} content={index + 1} />
                <Text style={styles.columnContent} content={formatDate(data?.date)} />
                <Text style={styles.columnContent} content="IPD Billing" />
                <Text style={{ ...styles.columnContent, width: '29%', textAlign:'left', marginLeft:'10px' }}
                  content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                <Text style={{ ...styles.columnContent, width: '11%' }} content={data.patient?.uhid} />
                <Text style={{ ...styles.columnContent, width: '12%' }} content={data.ipd_no} />
                <Text style={{ ...styles.columnContent, width: '12%' }} content={data.pay_mode} />
                <Text style={{ ...styles.columnContent, width: '25%' }} content={data.patient.consultant.name} />
                <Text style={{ ...styles.columnContent, width: '22%', textAlign:'left' }} content={data.combinedServiceDetails
                    .map(({ service_name, test_name }) => service_name || test_name)
                    .join(', ')} />
                <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                <Text style={styles.columnNumberContent} content={data.total_amt} />
                <Text style={styles.columnNumberContent} content={data.disc_amt} />
                <Text style={styles.columnNumberContent} content={data.total_recd} />
                <Text style={{ ...styles.columnNumberContent, marginRight: '2px' }} content={data.balance_amt} />
                <Text style={{ ...styles.columnContent, width: '19%' }} content={data.createdBy} />
              </View>
            ))}
          <View style={{ marginLeft: '59%', marginTop: '10px', flexDirection: 'row', marginBottom: 0 }}>
            <Text style={{ ...styles.columnContent, width: '94px', fontSize: "9px", fontFamily: "Roboto", color:'red' }} content="IPD COLLECTION :" />
            <Text style={{ ...styles.columnContent, width: '48px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.indoorServiceData?.stats?.bill_amt} />
            <Text style={{ ...styles.columnContent, width: '44px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.indoorServiceData?.stats?.disc_amt} />
            <Text style={{ ...styles.columnContent, width: '44px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.indoorServiceData?.stats?.recd_amt} />
            <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} content={data?.indoorServiceData?.stats?.bal_amt} />
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default IndoorCollectionRegisterReportPdf;
